import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import scholarshipsService from "./scholarshipsService"

const initialState = {
    scholarships: [],
    isLoading: false,
    isError: false,
    currentPage: 1,
    lastPage: 1,
    perPage: 16,
    scholarshipDetails: {},
    nextPageURI: null,
    prevPageURI: null,
    pageContent: {},
}

export const fetchScholarships = createAsyncThunk(
    "scholarships/fetchScholarships",
    async (currentPage, thunkAPI) => {
        try {
            const { getState } = thunkAPI
            const state = getState().scholarshipsPage
            return await scholarshipsService.fetchScholarships(
                state.perPage,
                currentPage
            )
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const fetchPageContent = createAsyncThunk(
    "scholarships/fetchPageContent",
    async (slug, thunkAPI) => {
        try {
            return await scholarshipsService.fetchPageContent(slug)
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const fetchScholarshipDetails = createAsyncThunk(
    "scholarships/fetchScholarshipDetails",
    async (slug, thunkAPI) => {
        try {
            return await scholarshipsService.fetchScholarshipDetails(slug)
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const scholarshipsSlice = createSlice({
    name: "scholarships",
    initialState,
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchScholarships.pending, (state) => {
                state.isLoading = true
            })
            .addCase(fetchScholarships.fulfilled, (state, action) => {
                state.isLoading = false
                state.scholarships = [
                    ...state.scholarships,
                    ...action.payload.data,
                ]
                state.currentPage = action.payload.current_page
                state.lastPage = action.payload.last_page
                state.nextPageURI = action.payload.next_page_url
                state.prevPageURI = action.payload.prev_page_url
            })
            .addCase(fetchScholarships.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.scholarships = []
                state.currentPage = 1
                state.lastPage = 1
                state.nextPageURI = null
                state.prevPageURI = null
                state.errorMessage = action.payload
            })
            .addCase(fetchPageContent.fulfilled, (state, action) => {
                state.pageContent = action.payload
            })
            .addCase(fetchPageContent.rejected, (state) => {
                state.pageContent = {}
            })
            .addCase(fetchScholarshipDetails.pending, (state) => {
                state.isLoading = true
            })
            .addCase(fetchScholarshipDetails.fulfilled, (state, action) => {
                state.isLoading = false
                state.scholarshipDetails = action.payload
            })
            .addCase(fetchScholarshipDetails.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.errorMessage = action.payload
            })
    },
})

export const { setCurrentPage } = scholarshipsSlice.actions
export default scholarshipsSlice.reducer
